<template>
  <review-layout class="page-program-detail"
                 :program-id="programId"
                 :show-bottom-bar="showBottomBar"
                 :reply-review="replyReview"
                 :reviews="reviews"
  >
    <div class="review-block">
      <div class="review-content">
        <review-list :reviews="reviews.list"
                     :next-start="reviews.start"
                     :target-id="programId"
                     target-type="program"
                     show-reply
                     @reply="handleClickReply"
        />
      </div>
    </div>
  </review-layout>
</template>

<script>
  import ReviewLayout from '@/pages/AudioProgram/components/ReviewLayout';
  import ReviewList from '@/components/CommentList/List';
  import { getAudioCommentList } from '@/services/comment';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'PageProgramReviewList',
    metaInfo() {
      return {
        title: `${this.reviews.count}条评论`,
      };
    },
    components: {
      ReviewLayout,
      ReviewList,
    },
    data() {
      return {
        programId: 0,
        showBottomBar: true,
        reviews: {
          list: [],
          start: 0,
          count: 0,
        },
        reviewAllLoad: false,
        replyReview: null,
        loading: false,
      };
    },
    methods: {
      async getReviewList(id) {
        const data = await getAudioCommentList({
          targetId: id,
          targetType: 'program',
          start: this.reviews.start,
          limit: LIMIT,
        });
        this.reviews.count = data.count;
        this.reviews.list = data.list;
        this.reviews.start = data.start;
      },

      handleClickReply(review) {
        this.replyReview = review;
      },
    },
    created() {
      const { id } = this.$route.params;
      this.programId = parseInt(id, 10);
      this.getReviewList(id);
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.getReviewList(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .review-block {
    background-color: @color-white;
  }

  .review-content {
    padding-bottom: @size-base;
  }
</style>
